export const en = {
  eyebrow: 'AKAS HRIS Pricing 2026',
  title: 'HRMS Pricing Plans',
  description:
    'Choose the HR and payroll package that matches your team size, operational needs, and preferred support level.',
  contactSales: 'Contact Sales',
  backToHrms: 'Back to HRMS',
  popularBadge: 'Advanced',
  standardSectionEyebrow: 'Standard Plan',
  modulesTitle: 'Modules & Features',
  advancedSectionEyebrow: 'Advanced Plan',
  advancedSectionTitle: 'Everything in Standard, plus advanced operations',
  supportEyebrow: 'Support',
  standardSupportTitle: 'Included Standard Support',
  premiumEyebrow: 'Premium Support',
  premiumSupportTitle: '$150 - $250 per month',
  examplesTitle: 'Examples',
  pricingPlans: [
    {
      name: 'Standard Plan',
      description: 'Designed for SMEs looking for a reliable and localized HR & Payroll solution.',
      price: '$1',
      period: 'per employee / month',
      minimum: 'Minimum monthly fee: $50',
      setup: 'One-time setup fee: $300 - $500',
      highlight: false,
    },
    {
      name: 'Advanced Plan',
      description: 'Designed for growing businesses and enterprises requiring advanced HR operations and process automation.',
      price: '$2',
      period: 'per employee / month',
      minimum: 'Minimum monthly fee: $100',
      setup: 'One-time setup fee: $600 - $1,000',
      highlight: true,
    },
  ],
  standardFeatureGroups: [
    {
      title: 'Core HR',
      features: [
        'Personnel Management',
        'Employee Profile & Document Management',
        'Organizational Chart',
        'Multi-branch & Department Structure',
        'Multi-currency Support and exchange rate: Transactions, Salary Tax, NSSF',
      ],
    },
    {
      title: 'Workforce Management',
      features: [
        'Attendance Management',
        'Shift & Schedule Management',
        'Leave & Holiday Management',
        'Overtime Tracking',
      ],
    },
    {
      title: 'Payroll',
      features: [
        'Payroll Processing',
        'NSSF Contribution Management',
        'Pension Fund Calculation',
        'Allowance & Deduction Management',
        'Khmer & English Payslip',
      ],
    },
    {
      title: 'Workflow & Automation',
      features: [
        'Approval Workflows',
        'Notifications & Alerts',
        'Employee Self-Service',
      ],
    },
    {
      title: 'Reporting & Customization',
      features: [
        'Forms Customization',
        'Reports Customization',
        'Export to Excel/PDF',
      ],
    },
    {
      title: 'Standard Support',
      features: ['Included for free'],
    },
  ],
  advancedFeatureGroups: [
    {
      title: 'Talent Acquisition',
      features: [
        'Recruitment Management',
        'Job Vacancy Tracking',
        'Candidate Pipeline',
        'Interview Scheduling',
        'Applicant Database',
      ],
    },
    {
      title: 'Performance Management',
      features: [
        'Performance Review System',
        'KPI & Goal Tracking',
        'Manager & Employee Assessments - Multiple lines of reviewer (360)',
      ],
    },
    {
      title: 'Flex List (Dynamic Business Process Module)',
      description: 'Empower users to build their own operational workflows without development.',
      features: [
        'Custom List Builder',
        'Dynamic Form Creation',
        'Approval Flow Configuration',
        'Status Tracking',
        'Custom Fields',
        'Role-based Access',
        'Workflow Notifications',
      ],
      examples: [
        'Purchase Requests',
        'Asset Requests',
        'Travel Requests',
        'Expense Claims',
        'Internal Approval Processes',
      ],
    },
  ],
  standardSupportGroups: [
    {
      title: 'System Maintenance',
      features: [
        'Bug fixes',
        'Minor issue troubleshooting',
        'Performance monitoring',
        'Database maintenance',
        'Backup verification',
      ],
    },
    {
      title: 'User Support',
      features: [
        'Email support',
        'Telegram/Chat support during office hours',
        'Basic user guidance',
        'Password reset assistance',
        'User access troubleshooting',
        'Attendance sync troubleshooting',
      ],
    },
    {
      title: 'Functional Assistance',
      features: [
        'Payroll calculation issue checking',
        'Leave balance issue checking',
        'Attendance discrepancy review',
        'Report troubleshooting',
        'Basic workflow configuration help',
      ],
    },
    {
      title: 'Updates',
      features: [
        'Standard product updates',
        'Regulatory updates (Cambodia labor/payslip/tax related)',
        'Minor UI improvements',
        'Compatibility updates',
      ],
    },
  ],
  premiumSupportGroups: [
    {
      title: 'Priority Technical Support',
      features: [
        'Priority bug fixing queue',
        'Faster incident response',
        'Emergency support',
        'After-hours support',
        'Weekend support',
        'Hotline support',
        'Dedicated account manager',
      ],
    },
    {
      title: 'Advanced Troubleshooting',
      features: [
        'Payroll emergency handling',
        'Attendance device integration troubleshooting',
        'API troubleshooting',
        'Performance optimization',
        'Server resource analysis',
      ],
    },
    {
      title: 'Customization Support',
      features: [
        'Small feature enhancements',
        'Custom report creation',
        'Workflow adjustments',
        'Approval flow modifications',
        'Custom field configuration',
        'Template modifications',
        'HR policy configuration assistance',
      ],
    },
    {
      title: 'Business & Operational Support',
      features: [
        'Monthly system health review',
        'Usage analytics review',
        'HR process consultation',
        'Payroll process optimization',
        'Compliance advisory',
        'Best-practice recommendations',
      ],
    },
    {
      title: 'Advanced Operational Services',
      features: [
        'Disaster recovery assistance',
        'Priority backup restoration',
        'Data migration assistance',
        'Integration monitoring',
        'Server monitoring',
        'Scheduled maintenance coordination',
      ],
    },
  ],
};

export type Copy = typeof en;

export const km: Copy = {
  eyebrow: 'តម្លៃប្រព័ន្ធគ្រប់គ្រងធនធានមនុស្ស AKAS ឆ្នាំ 2026',
  title: 'ផែនការតម្លៃប្រព័ន្ធគ្រប់គ្រងធនធានមនុស្ស',
  description:
    'ជ្រើសរើសកញ្ចប់ធនធានមនុស្ស និងការគណនាប្រាក់ខែ ដែលសមនឹងទំហំក្រុមការងារ តម្រូវការប្រតិបត្តិការ និងកម្រិតជំនួយដែលអ្នកចង់បាន។',
  contactSales: 'ទំនាក់ទំនងផ្នែកលក់',
  backToHrms: 'ត្រឡប់ទៅធនធានមនុស្ស',
  popularBadge: 'កម្រិតខ្ពស់',
  standardSectionEyebrow: 'ផែនការស្តង់ដារ',
  modulesTitle: 'ម៉ូឌុល និងលក្ខណៈពិសេស',
  advancedSectionEyebrow: 'ផែនការកម្រិតខ្ពស់',
  advancedSectionTitle: 'អ្វីៗទាំងអស់ក្នុងផែនការស្តង់ដារ បន្ថែមប្រតិបត្តិការកម្រិតខ្ពស់',
  supportEyebrow: 'ជំនួយ',
  standardSupportTitle: 'ជំនួយស្តង់ដារដែលរួមបញ្ចូលឥតគិតថ្លៃ',
  premiumEyebrow: 'ជំនួយកម្រិតខ្ពស់',
  premiumSupportTitle: '$150 - $250 ក្នុងមួយខែ',
  examplesTitle: 'ឧទាហរណ៍',
  pricingPlans: [
    {
      name: 'ផែនការស្តង់ដារ',
      description: 'សម្រាប់សហគ្រាសខ្នាតតូច និងមធ្យម ដែលចង់បានដំណោះស្រាយធនធានមនុស្ស និងប្រាក់ខែដែលអាចទុកចិត្តបាន និងស្របនឹងបរិបទកម្ពុជា។',
      price: '$1',
      period: 'ក្នុងមួយបុគ្គលិក / ខែ',
      minimum: 'ថ្លៃប្រចាំខែអប្បបរមា៖ $50',
      setup: 'ថ្លៃដំឡើងគ្រាដំបូង៖ $300 - $500',
      highlight: false,
    },
    {
      name: 'ផែនការកម្រិតខ្ពស់',
      description: 'សម្រាប់អាជីវកម្មកំពុងរីកចម្រើន និងសហគ្រាសធំ ដែលត្រូវការប្រតិបត្តិការធនធានមនុស្សកម្រិតខ្ពស់ និងស្វ័យប្រវត្តិកម្មដំណើរការ។',
      price: '$2',
      period: 'ក្នុងមួយបុគ្គលិក / ខែ',
      minimum: 'ថ្លៃប្រចាំខែអប្បបរមា៖ $100',
      setup: 'ថ្លៃដំឡើងគ្រាដំបូង៖ $600 - $1,000',
      highlight: true,
    },
  ],
  standardFeatureGroups: [
    {
      title: 'ធនធានមនុស្សមូលដ្ឋាន',
      features: [
        'ការគ្រប់គ្រងព័ត៌មានបុគ្គលិក',
        'ប្រវត្តិរូបបុគ្គលិក និងការគ្រប់គ្រងឯកសារ',
        'តារាងរចនាសម្ព័ន្ធអង្គភាព',
        'រចនាសម្ព័ន្ធសាខា និងនាយកដ្ឋានច្រើន',
        'គាំទ្ររូបិយប័ណ្ណច្រើន និងអត្រាប្តូរប្រាក់៖ ប្រតិបត្តិការ ពន្ធលើប្រាក់ខែ បេឡាជាតិសន្តិសុខសង្គម',
      ],
    },
    {
      title: 'ការគ្រប់គ្រងកម្លាំងការងារ',
      features: [
        'ការគ្រប់គ្រងវត្តមាន',
        'ការគ្រប់គ្រងវេន និងកាលវិភាគ',
        'ការគ្រប់គ្រងការឈប់សម្រាក និងថ្ងៃឈប់សម្រាក',
        'ការតាមដានម៉ោងបន្ថែម',
      ],
    },
    {
      title: 'ការគណនាប្រាក់ខែ',
      features: [
        'ដំណើរការគណនាប្រាក់ខែ',
        'ការគ្រប់គ្រងការរួមចំណែកបេឡាជាតិសន្តិសុខសង្គម',
        'ការគណនាមូលនិធិចូលនិវត្តន៍',
        'ការគ្រប់គ្រងប្រាក់ឧបត្ថម្ភ និងការកាត់ប្រាក់',
        'ស្លឹកប្រាក់ខែជាភាសាខ្មែរ និងអង់គ្លេស',
      ],
    },
    {
      title: 'ដំណើរការការងារ និងស្វ័យប្រវត្តិកម្ម',
      features: [
        'ដំណើរការអនុម័ត',
        'ការជូនដំណឹង និងការរំលឹក',
        'សេវាដោយខ្លួនឯងសម្រាប់បុគ្គលិក',
      ],
    },
    {
      title: 'របាយការណ៍ និងការកែតាមតម្រូវការ',
      features: [
        'កែទម្រង់ឯកសារតាមតម្រូវការ',
        'កែរបាយការណ៍តាមតម្រូវការ',
        'នាំចេញជាតារាងគណនា ឬ PDF',
      ],
    },
    {
      title: 'ជំនួយស្តង់ដារ',
      features: ['រួមបញ្ចូលដោយឥតគិតថ្លៃ'],
    },
  ],
  advancedFeatureGroups: [
    {
      title: 'ការទាក់ទាញទេពកោសល្យ',
      features: [
        'ការគ្រប់គ្រងការជ្រើសរើសបុគ្គលិក',
        'ការតាមដានតំណែងទំនេរ',
        'បញ្ជីបេក្ខជនតាមដំណាក់កាល',
        'ការកំណត់កាលវិភាគសម្ភាសន៍',
        'មូលដ្ឋានទិន្នន័យអ្នកដាក់ពាក្យ',
      ],
    },
    {
      title: 'ការគ្រប់គ្រងលទ្ធផលការងារ',
      features: [
        'ប្រព័ន្ធវាយតម្លៃលទ្ធផលការងារ',
        'ការតាមដានសូចនាករសមិទ្ធផលការងារ និងគោលដៅ',
        'ការវាយតម្លៃដោយអ្នកគ្រប់គ្រង និងបុគ្គលិក — អ្នកវាយតម្លៃច្រើនជាន់ (360)',
      ],
    },
    {
      title: 'បញ្ជីបត់បែន (ម៉ូឌុលដំណើរការអាជីវកម្មដែលកំណត់បានដោយខ្លួនឯង)',
      description: 'ឲ្យអ្នកប្រើប្រាស់បង្កើតដំណើរការការងារប្រតិបត្តិការដោយខ្លួនឯង ដោយមិនត្រូវការអ្នកសរសេរកម្មវិធី។',
      features: [
        'កម្មវិធីបង្កើតបញ្ជីផ្ទាល់ខ្លួន',
        'ការបង្កើតទម្រង់ដែលអាចប្តូរតាមតម្រូវការ',
        'ការកំណត់លំហូរអនុម័ត',
        'ការតាមដានស្ថានភាព',
        'វាលទិន្នន័យផ្ទាល់ខ្លួន',
        'សិទ្ធិចូលប្រើតាមតួនាទី',
        'ការជូនដំណឹងតាមដំណើរការការងារ',
      ],
      examples: [
        'សំណើសុំទិញ',
        'សំណើសុំទ្រព្យសកម្ម',
        'សំណើសុំធ្វើដំណើរ',
        'សំណើសុំសំណងចំណាយ',
        'ដំណើរការអនុម័តផ្ទៃក្នុង',
      ],
    },
  ],
  standardSupportGroups: [
    {
      title: 'ការថែទាំប្រព័ន្ធ',
      features: [
        'កែកំហុសកម្មវិធី',
        'ដោះស្រាយបញ្ហាតូចតាច',
        'ត្រួតពិនិត្យសមត្ថភាពដំណើរការ',
        'ថែទាំមូលដ្ឋានទិន្នន័យ',
        'ផ្ទៀងផ្ទាត់ការបម្រុងទុកទិន្នន័យ',
      ],
    },
    {
      title: 'ជំនួយអ្នកប្រើប្រាស់',
      features: [
        'ជំនួយតាមអ៊ីមែល',
        'ជំនួយតាមសារឆាត ក្នុងម៉ោងធ្វើការ',
        'ការណែនាំអ្នកប្រើប្រាស់ជាមូលដ្ឋាន',
        'ជំនួយកំណត់ពាក្យសម្ងាត់ឡើងវិញ',
        'ដោះស្រាយបញ្ហាការចូលប្រើរបស់អ្នកប្រើប្រាស់',
        'ដោះស្រាយបញ្ហាការធ្វើសមកាលកម្មវត្តមាន',
      ],
    },
    {
      title: 'ជំនួយផ្នែកមុខងារ',
      features: [
        'ពិនិត្យបញ្ហាការគណនាប្រាក់ខែ',
        'ពិនិត្យបញ្ហាសមតុល្យថ្ងៃឈប់សម្រាក',
        'ពិនិត្យភាពមិនស៊ីគ្នានៃវត្តមាន',
        'ដោះស្រាយបញ្ហារបាយការណ៍',
        'ជំនួយកំណត់ដំណើរការការងារជាមូលដ្ឋាន',
      ],
    },
    {
      title: 'ការធ្វើបច្ចុប្បន្នភាព',
      features: [
        'ការធ្វើបច្ចុប្បន្នភាពផលិតផលស្តង់ដារ',
        'ការធ្វើបច្ចុប្បន្នភាពតាមបទប្បញ្ញត្តិ (ច្បាប់ការងារ ស្លឹកប្រាក់ខែ និងពន្ធនៅកម្ពុជា)',
        'ការកែលម្អផ្ទៃប្រើប្រាស់តូចៗ',
        'ការធ្វើបច្ចុប្បន្នភាពដើម្បីរក្សាភាពឆបគ្នា',
      ],
    },
  ],
  premiumSupportGroups: [
    {
      title: 'ជំនួយបច្ចេកទេសអាទិភាព',
      features: [
        'ជួរកែកំហុសតាមអាទិភាព',
        'ការឆ្លើយតបបញ្ហាលឿនជាងមុន',
        'ជំនួយពេលអាសន្ន',
        'ជំនួយក្រៅម៉ោងធ្វើការ',
        'ជំនួយថ្ងៃចុងសប្តាហ៍',
        'ជំនួយតាមខ្សែទូរស័ព្ទផ្ទាល់',
        'អ្នកគ្រប់គ្រងគណនីផ្ទាល់',
      ],
    },
    {
      title: 'ការដោះស្រាយបញ្ហាកម្រិតខ្ពស់',
      features: [
        'ការដោះស្រាយបញ្ហាប្រាក់ខែជាបន្ទាន់',
        'ដោះស្រាយបញ្ហាការតភ្ជាប់ឧបករណ៍វត្តមាន',
        'ដោះស្រាយបញ្ហាការតភ្ជាប់ប្រព័ន្ធខាងក្រៅ',
        'ការបង្កើនសមត្ថភាពដំណើរការ',
        'ការវិភាគធនធានម៉ាស៊ីនមេ',
      ],
    },
    {
      title: 'ជំនួយផ្នែកកែតម្រូវតាមតម្រូវការ',
      features: [
        'ការបន្ថែមមុខងារតូចៗ',
        'ការបង្កើតរបាយការណ៍ផ្ទាល់ខ្លួន',
        'ការកែតម្រូវដំណើរការការងារ',
        'ការកែប្រែលំហូរអនុម័ត',
        'ការកំណត់វាលទិន្នន័យផ្ទាល់ខ្លួន',
        'ការកែគំរូឯកសារ',
        'ជំនួយកំណត់គោលការណ៍ធនធានមនុស្ស',
      ],
    },
    {
      title: 'ជំនួយអាជីវកម្ម និងប្រតិបត្តិការ',
      features: [
        'ពិនិត្យសុខភាពប្រព័ន្ធប្រចាំខែ',
        'ពិនិត្យការវិភាគការប្រើប្រាស់',
        'ប្រឹក្សាដំណើរការធនធានមនុស្ស',
        'កែលម្អដំណើរការបើកប្រាក់ខែ',
        'ប្រឹក្សាអំពីការអនុលោមតាមច្បាប់',
        'អនុសាសន៍អំពីវិធីអនុវត្តល្អបំផុត',
      ],
    },
    {
      title: 'សេវាប្រតិបត្តិការកម្រិតខ្ពស់',
      features: [
        'ជំនួយស្តារប្រព័ន្ធពេលមានគ្រោះថ្នាក់',
        'ការស្តារទិន្នន័យបម្រុងឡើងវិញតាមអាទិភាព',
        'ជំនួយក្នុងការផ្លាស់ទីទិន្នន័យ',
        'ការត្រួតពិនិត្យការតភ្ជាប់ប្រព័ន្ធ',
        'ការត្រួតពិនិត្យម៉ាស៊ីនមេ',
        'សម្របសម្រួលការថែទាំតាមកាលវិភាគ',
      ],
    },
  ],
};
